import { useState, createContext, useContext } from "react";
import { handleData } from "../api";
import { fullName } from '../helperfunctions/helperfunctions';


const AdminUsersContext = createContext(null);

export const AdminUsersProvider = ({children}) => {

    const [adminUsers, setAdminUsers] = useState(null);

    const loadAdminUsers = async() => {
        const data = {
            method: 'GET',
            path: 'users'
        }
        const result = await handleData(data);
        if (result.data.data) {
            const rawUsers = result.data.data;
            const userList = rawUsers.map(item => {
                const naam = fullName(item);
                const info = item.info || "";
                return {
                    naam,
                    gebruikersnaam: item.gebruikersnaam,
                    achternaam: item.achternaam,
                    voornaam: item.voornaam,
                    tussenvoegsel: item.tussenvoegsel,
                    loginemail: item.loginemail,
                    contactemail: item.contactemail,
                    info,
                    _id: item._id
                }
            });
            setAdminUsers(userList);
        }
    }

    return (
        <AdminUsersContext.Provider
            value={{
                adminUsers,
                loadAdminUsers
            }}
        >
            {children}
        </AdminUsersContext.Provider>
    );
}

export const useAdminUsers = () => {
    return useContext(AdminUsersContext);
}